import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'dropdown', 'hiddenField', 'clearBtn', 'chevron', 'notListedBtn'];
  static values = {
    minChars: { type: Number, default: 3 },
    defaultOrgId: { type: Number, default: 0 }
  };

  connect() {
    this.options = [...this.dropdownTarget.querySelectorAll('button[data-id]')];
    this.form = this.element.closest('form');
    document.addEventListener('click', this.handleClickOutside);
    if (this.form) this.form.addEventListener('submit', this.validateSelection);

    // If a value is already selected, show clear button and hide chevron
    if (this.hiddenFieldTarget.value) {
      this.showSelected();
    }
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside);
    if (this.form) this.form.removeEventListener('submit', this.validateSelection);
  }

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase();

    if (query.length < this.minCharsValue) {
      this.hideDropdown();
      return;
    }

    let matchCount = 0;
    this.options.forEach((option) => {
      const name = option.dataset.name.toLowerCase();
      const visible = name.includes(query);
      option.classList.toggle('hidden', !visible);
      if (visible) matchCount++;
    });

    // Always show the dropdown when there's a query (for the "not listed" option)
    this.showDropdown();
  }

  onFocus() {
    // If no selection yet and enough chars typed, show filtered results
    if (!this.hiddenFieldTarget.value) {
      this.filter();
    }
  }

  select(event) {
    const { id, name } = event.currentTarget.dataset;

    this.hiddenFieldTarget.value = id;
    this.inputTarget.value = name;
    this.inputTarget.readOnly = true;
    this.hideDropdown();
    this.showSelected();
    this.clearError();
  }

  selectNotListed() {
    this.hiddenFieldTarget.value = this.defaultOrgIdValue;
    this.inputTarget.value = 'My employer is not listed';
    this.inputTarget.readOnly = true;
    this.hideDropdown();
    this.showSelected();
    this.clearError();
  }

  clear() {
    this.hiddenFieldTarget.value = '';
    this.inputTarget.value = '';
    this.inputTarget.readOnly = false;
    this.inputTarget.focus();
    this.hideSelected();

    // Reset all options to visible
    this.options.forEach((option) => option.classList.remove('hidden'));
  }

  showDropdown() {
    this.dropdownTarget.classList.remove('hidden');
  }

  hideDropdown() {
    this.dropdownTarget.classList.add('hidden');
  }

  showSelected() {
    this.clearBtnTarget.classList.remove('hidden');
    this.chevronTarget.classList.add('hidden');
  }

  hideSelected() {
    this.clearBtnTarget.classList.add('hidden');
    this.chevronTarget.classList.remove('hidden');
  }

  clearError() {
    this.inputTarget.classList.remove('border-pink-900', 'bg-pink-50', 'text-pink-900');
    this.inputTarget.classList.add('border-stone-300', 'border-opacity-50', 'text-stone-500', 'bg-white');
  }

  validateSelection = (event) => {
    if (!this.hiddenFieldTarget.value) {
      event.preventDefault();
      this.inputTarget.classList.add('border-pink-900', 'bg-pink-50', 'text-pink-900');
      this.inputTarget.classList.remove('border-stone-300', 'border-opacity-50', 'text-stone-500', 'bg-white');
      this.inputTarget.focus();
    }
  };

  handleClickOutside = (event) => {
    if (!this.element.contains(event.target)) {
      this.hideDropdown();
    }
  };
}
